import React from 'react'
// import Wallpaper from "./Wallpaper"
// import Intro from './Intro'
import Footer from '../Footer'
import About from '../aboutme/About'
import Projects from '../project/Projects'
const Home = () => {
    return (
        <div>


            {/* <Wallpaper /> */}
            <About/>

            {/* <Intro /> */}
            <Projects/>

            <Footer />

        </div>
    )
}

export default Home